// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3FWrC","inputWrap":"styles_inputWrap__2QrS4","input":"styles_input__2oG0D"};